import { render, staticRenderFns } from "./AccountButton.vue?vue&type=template&id=4b223b7e&scoped=true&"
import script from "./AccountButton.vue?vue&type=script&lang=ts&"
export * from "./AccountButton.vue?vue&type=script&lang=ts&"
import style0 from "./AccountButton.vue?vue&type=style&index=0&id=4b223b7e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b223b7e",
  null
  
)

export default component.exports